export class PaytmRequestDto {
	customerName: string;
	customerMobile: string;
	customerEmail: string;
	message: string;
	amount: Number;
	locId: string;
}